import { useEffect, useState } from 'react'

export function useLockScroll() {
  const [locked, setLocked] = useState(false)

  const lock = () => {
    setLocked(true)
    document.querySelector('html').style.overflow = 'hidden'
  }
  const unlock = () => {
    setLocked(false)
    document.querySelector('html').style.overflow = 'visible'
  }
  const toggle = () => (locked ? unlock() : lock())

  useEffect(() => {
    return () => {
      unlock()
    }
  }, [])

  return { locked, lock, unlock, toggle }
}
